export default {
  props: {
    animation: Boolean
  },
  data: function () {
    return {
      styles: [],
      categories: [],
      mediums: [],
      gals: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init: async function () {
      let galleries = await this.$store.dispatch('fetchGalleries')
      
      let gals = galleries.filter(el => (el.animation === this.animation))
      this.gals = gals.sort((el, el2) => { return el.name.localeCompare(el2.name) })
      if(this.animation) {
        this.styles = gals.filter(el => el.category === 'category')
        this.categories = []
        this.mediums = []
      }
      else {
        this.styles = gals.filter(el => el.category === 'style')
        this.categories = gals.filter(el => el.category === 'category')
        this.mediums = gals.filter(el => el.category === 'medium')
      }
      
    }
  }
}